// Email magic-link sign-in — for people who don't use Google/Microsoft (e.g.
// iCloud-only users). Shared by Landing and Invite. Collects an email, sends the
// Supabase magic link, and shows a "check your inbox" state. Identity only — the
// user connects their calendar (iCloud) after they land.
import { useState } from 'react';
import { auth } from '../lib/supabase';
import { capture } from '../lib/analytics';
import { TextInput, Button } from './ui';

export default function EmailSignIn({ redirectTo }) {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle'); // idle | sending | sent | error
  const [error, setError] = useState(null);

  const send = async (e) => {
    e?.preventDefault();
    const addr = email.trim();
    if (!addr) return;
    setStatus('sending'); setError(null);
    try {
      capture('signin_started', { provider: 'email' });
      await auth.signInWithEmail(addr, { redirectTo });
      setStatus('sent');
    } catch (err) {
      setError('Couldn\'t send the link. Check the address and try again.');
      setStatus('error');
    }
  };

  if (status === 'sent') {
    return (
      <div className="border border-line px-5 py-6">
        <p className="font-mono text-xs uppercase tracking-widest text-accent">check your inbox</p>
        <p className="mt-3 font-sans text-base text-ink/80">
          We emailed a sign-in link to <span className="text-ink">{email.trim()}</span>. Open it on
          this device to continue.
        </p>
      </div>
    );
  }

  return (
    <form onSubmit={send} className="space-y-3">
      <p className="font-sans text-sm text-ink/60">
        For iCloud / Apple Calendar. We'll email you a sign-in link, then you connect your
        calendar — no Google needed.
      </p>
      <TextInput
        id="email-signin"
        type="email"
        label="Email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="you@icloud.com"
        autoComplete="email"
        disabled={status === 'sending'}
        required
      />
      <Button type="submit" disabled={status === 'sending' || !email.trim()}>
        {status === 'sending' ? 'Sending…' : 'Email me a sign-in link'}
      </Button>
      {error && <p className="font-mono text-xs text-red-700">{error}</p>}
    </form>
  );
}
